<bs-digital-linear-result-model-header
    [title]="title"
    [subtitle]="subTitle"
    [expand]="expanded"
    [oddsDisplayFormat]="oddsDisplayFormat"
    [odds]="totalOdds"
    [boostedOdds]="boostedOdds"
    (expandToggled)="toggleExpand($event)" />

@if (expanded) {
    @for (slip of succeededSlips; track slip.betNumber; let last = $last) {
        @let firstPick = slip.picks[0].clientPick;
        @if (isBetBuilderPick(firstPick)) {
            <bs-linear-bet-builder-pick-display-header
                [pick]="firstPick"
                [betslipType]="betType"
                [oddsDisplayFormat]="oddsDisplayFormat"
                [hideOdds]="showOneBetBuilderPerModule" />

            <bs-linear-bet-builder-selections-list [pick]="firstPick" [inlineDetails]="!isEpcotEnabled" />

            <bs-digital-linear-result-bet-returns
                [stake]="getStake(slip.betNumber)"
                [possibleWinningsNet]="getPossibleWinningsNet(slip.betNumber)"
                [possibleWinningsGross]="getPossibleWinningsGross(slip.betNumber)"
                [rewardTokenInfo]="getRewardTokenInfo(slip.betNumber)"
                [boostedValue]="getBoostedValue(slip.betNumber)" />

            @if (!last) {
                <div class="separator"></div>
            }
        }
    }
    <bs-digital-result-keep-placed
        *ngIf="resultState$ | async as resultState"
        [isLinear]="true"
        [keepPlaced]="keepPlaced(resultState)"
        [betType]="keepPlacedBetId"
        (keepPlacedChanged)="onKeepPlacedChanged($event)" />

    <bs-digital-linear-result-links [succeededSlips]="succeededSlips" [inColumn]="inColumn" />
}
